import React from 'react';
import ContentoQuery from 'app/components/Contento/ContentoQuery';
import Link from 'next/link';
import MAIN_GENRES_QUERY from '../../../PromotionGrid/MainGenres.graphql';
import { Genres, GenresList, GenreListRow, GenreLink, GenresListElement } from './FooterGenres.styles';
import PlayText, { SIZE } from '../../../../ui-components/typography/PlayText/PlayText';
import { regularWhite } from '../../../../ui-components/design-tokens';

export const sliceArrayIntoChunks = (array: Array<any>, chunkSize: number): Array<Array<any>> => {
    const res = [];
    for (let i = 0; i < array.length; i += chunkSize) {
        const chunk = array.slice(i, i + chunkSize);
        res.push(chunk);
    }

    return res;
};

type Props = {
    onGenreClick: (name: string) => void;
};

const FooterGenres = ({ onGenreClick }: Props): JSX.Element => (
    <ContentoQuery query={MAIN_GENRES_QUERY}>
        {(data: any) => {
            const mainGenres = data.genres;

            if (!mainGenres || !mainGenres.length) {
                return null;
            }

            const chunkedGenres = sliceArrayIntoChunks(mainGenres, 4);

            return (
                <Genres>
                    <GenresList>
                        {chunkedGenres.map((chunk: Array<any>, i: number) => (
                            <GenreListRow key={`genrelist-row-${i}`}>
                                {chunk.map((item: any) => (
                                    <GenresListElement key={`genrelist-element-${item.id}`}>
                                        <PlayText size={SIZE.LARGE} fontColor={regularWhite}>
                                            <Link
                                                href={item.link ? item.link : `/kategori/${item.id}`}
                                                passHref
                                            >
                                                <GenreLink
                                                    onClick={() => {
                                                        onGenreClick(item.name);
                                                    }}
                                                >
                                                    <span>{item.name}</span>
                                                </GenreLink>
                                            </Link>
                                        </PlayText>
                                    </GenresListElement>
                                ))}
                                {i + 1 === chunkedGenres.length && (
                                    <GenresListElement key="genrelist-row-last">
                                        <PlayText size={SIZE.LARGE} fontColor={regularWhite}>
                                            <Link href="/program" passHref>
                                                <GenreLink
                                                    className={`lp_pos${i}`}
                                                    onClick={() => {
                                                        onGenreClick('Alla program');
                                                    }}
                                                >
                                                    <span>Alla program</span>
                                                </GenreLink>
                                            </Link>
                                        </PlayText>
                                    </GenresListElement>
                                )}
                            </GenreListRow>
                        ))}
                    </GenresList>
                </Genres>
            );
        }}
    </ContentoQuery>
);

export default FooterGenres;
